// src/components/About/About.js
import React, { useState, useEffect } from 'react';
import './About.css';
import emreuygun from '../../assets/emreuygun.jpeg';
import emreuygun2 from '../../assets/emreuygun2.jpeg';
import { Link } from 'react-router-dom';

function About() {
  const images = [emreuygun, emreuygun2];
  const [currentIndex, setCurrentIndex] = useState(0);

  // 3 saniyede bir fotoğrafı değiştiren zamanlayıcı (slider) kanka
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // 3000 = 3 saniye

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="about-section">
      <div className="container">
        <div className="about-wrapper">
          
          {/* Sol Kısım: Fotoğraf Slider ve Çerçeve Alanı */}
          <div className="about-image-container">
            {images.map((img, index) => (
              <img 
                key={index}
                src={img}
                alt="Avukat Emre Uygun" 
                className={`about-image ${index === currentIndex ? 'active' : ''}`}
              />
            ))}
            {/* Resmin kenarındaki şık gold çerçeve detayı (Z-index ile en üstte sabit) */}
            <div className="about-image-frame"></div>
          </div>

          {/* Sağ Kısım: Metin ve Bilgiler */}
          <div className="about-text-container">
            <h4 className="about-subtitle">HAKKIMIZDA</h4>
            <h2 className="about-title">Adalete Giden Yolda <br/><span className="gold-text">Güvenilir Rehberiniz</span></h2>
            
            <p className="about-description">
              Av. Emre Uygun Hukuk ve Danışmanlık Bürosu olarak, hukukun üstünlüğü ilkesinden taviz vermeden, müvekkillerimizin haklarını en güçlü şekilde savunuyoruz. Yılların getirdiği tecrübe ve dinamik yapımızla, her davaya özel ve sonuç odaklı stratejiler geliştiriyoruz.
            </p>
            
            <p className="about-description">
              Amacımız sadece hukuki uyuşmazlıkları çözmek değil, aynı zamanda olası riskleri önceden tespit ederek müvekkillerimize koruyucu avukatlık hizmeti sunmaktır.
            </p>

            {/* Neden Biz? - Tikli Maddeler */}
            <ul className="about-features">
              <li><span className="feature-icon">✓</span> Şeffaf Süreç Yönetimi</li>
              <li><span className="feature-icon">✓</span> Mutlak Gizlilik İlkesi</li>
              <li><span className="feature-icon">✓</span> Çözüm ve Sonuç Odaklılık</li>
              <li><span className="feature-icon">✓</span> Profesyonel Temsil</li>
            </ul>

            <Link to="/iletisim" className="btn-gold about-btn" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              Hemen İletişime Geçin
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}

export default About;